import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listClubs = () =>
  axios.get(`${getV2RootUrl()}/club/for-web`, publicAxiosHeaderV2());

export const getClub = (slug) =>
  axios.get(
    `${getV2RootUrl()}/club/slug/${slug}/for-web`,
    publicAxiosHeaderV2()
  );
